// extracted by mini-css-extract-plugin
export default {"bgColor":"TermsandConditions_bgColor__21bTu","title":"TermsandConditions_title__o7RR9","termsContent":"TermsandConditions_termsContent__+c1Mm"};